import React from 'react';

const AddTipModal = ({
  newTip,
  setNewTip,
  categories,
  createTip,
  onClose,
  isDarkMode
}) => {
  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className={`w-full max-w-md rounded-xl ${isDarkMode ? 'bg-gray-800' : 'bg-white'} p-5`}>
        <h3 className={`text-lg font-bold mb-4 ${isDarkMode ? 'text-white' : 'text-gray-800'}`}>Add New Tip</h3>
        
        <div className="space-y-4">
          <div>
            <label className={`block text-sm mb-1 ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>Category *</label>
            <select value={newTip.category} onChange={(e) => setNewTip(prev => ({ ...prev, category: e.target.value }))}
              className={`w-full px-3 py-2 rounded-lg border text-sm ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}>
              <option value="">Select category...</option>
              {categories.map(cat => (
                <option key={cat.id} value={cat.name}>{cat.emoji} {cat.label}</option>
              ))}
            </select>
          </div>
          
          <div>
            <label className={`block text-sm mb-1 ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>Content *</label>
            <textarea value={newTip.content} onChange={(e) => setNewTip(prev => ({ ...prev, content: e.target.value }))}
              className={`w-full px-3 py-2 rounded-lg border text-sm ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
              rows={2} placeholder="The main tip content (can be Darija word, fact, joke, etc.)" />
          </div>
          
          <div>
            <label className={`block text-sm mb-1 ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>Translation (if content is Darija)</label>
            <input type="text" value={newTip.translation} onChange={(e) => setNewTip(prev => ({ ...prev, translation: e.target.value }))}
              className={`w-full px-3 py-2 rounded-lg border text-sm ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
              placeholder="English translation" />
          </div>
          
          <div>
            <label className={`block text-sm mb-1 ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>Example usage</label>
            <input type="text" value={newTip.example} onChange={(e) => setNewTip(prev => ({ ...prev, example: e.target.value }))}
              className={`w-full px-3 py-2 rounded-lg border text-sm ${isDarkMode ? 'bg-gray-700 border-gray-600 text-white' : 'bg-white border-gray-300'}`}
              placeholder="How to use this word in a sentence" />
          </div>
        </div>
        
        <div className="flex justify-end gap-2 mt-6">
          <button onClick={onClose} className={`px-4 py-2 rounded-lg text-sm ${isDarkMode ? 'bg-gray-700 text-white' : 'bg-gray-200'}`}>Cancel</button>
          <button onClick={createTip} disabled={!newTip.category || !newTip.content} className="px-4 py-2 bg-purple-600 text-white rounded-lg text-sm disabled:opacity-50">Add Tip</button>
        </div>
      </div>
    </div>
  );
};

export default AddTipModal;
